import React from 'react'
import { Link } from 'react-router-dom'

import './index.styles.css'
interface RouterLinkProps {
  isExternal: boolean
  navigationPath: string
  generatedAction: () => void
  children: JSX.Element
}

const ResultLink = (props: RouterLinkProps) => {
  const { isExternal, navigationPath, generatedAction, children } = props

  if (isExternal) {
    return (
      <a
        className={'ResultLink_link'}
        href={navigationPath}
        onClick={generatedAction}
        target="_blank"
        rel="noreferrer"
        tabIndex={-1}
      >
        {children}
      </a>
    )
  }

  return (
    <Link onClick={generatedAction} to={`${navigationPath}?command_bar=true`} tabIndex={-1}>
      {children}
    </Link>
  )
}

export default React.memo(ResultLink)
